import { ObservableValue } from '@sensenet/client-utils';
import { ConstantContent } from "../Repository/ConstantContent.js";
import { LoginState } from "./LoginState.js";
/**
 * Default authentication service that bypasses the authentication process
 */

export class BypassAuthentication {
  constructor() {
    this.state = new ObservableValue(LoginState.Unknown);
    this.currentUser = new ObservableValue(ConstantContent.VISITOR_USER);
  }

  /**
   * Checks for update if neccessary. For BypassAuthentication always resolves immedietly with false
   */
  async checkForUpdate() {
    return false;
  }
  /**
   * Login method - not available for BypassAuthentication
   */


  async login() {
    throw new Error('Not allowed when authentication is bypassed.');
  }
  /**
   * logout method - not available for BypassAuthentication
   */


  async logout() {
    throw new Error('Not allowed when authentication is bypassed.');
  }
  /**
   * Current user observable property - Will publish the Visitor user for BypassAuthentication
   */


  /**
   * Disposes the service
   */
  dispose() {
    /** */
  }

}
//# sourceMappingURL=BypassAuthentication.js.map